import { useEffect, useState } from 'react';
import { Dimensions } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

export default function useOrientation(): string | null {
  const [orientation, setOrientation] = useState<string | null>(null);
  const { width, height } = useSafeAreaFrame();

  useEffect(() => {
    if (width < height) {
      setOrientation('PORTRAIT');
    } else {
      setOrientation('LANDSCAPE');
    }

    const subscription = Dimensions.addEventListener('change', () => {
      if (width < height) {
        setOrientation('PORTRAIT');
      } else {
        setOrientation('LANDSCAPE');
      }
    });
    return () => subscription?.remove();
  }, [height, width]);

  return orientation;
}
